import React from 'react';

const SatDim = (props = {}) => {
  const { zIndex = 200, isShow = false } = props;

  return (
    <div
      className="dim"
      style={{ display: isShow ? 'block' : 'none', zIndex }}
    />
  );
};

export default SatDim;
